export default class BackgroundImage {
  constructor() {
    'ngInject';

    this.restrict = 'A';
  }

  link($scope, element, attrs) {
    const url = attrs.backgroundImage;
    element.css({
      background: `url('${url}') no-repeat center center fixed`,
      'background-size': 'cover'
    });
  }

  static directiveFactory() {
    'ngInject';

    return new BackgroundImage();
  }
}



// WEBPACK FOOTER //
// ./common/directives/background-image.js